var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoPattern = function SvgLogoPattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 57,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CD1C45",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.134,
    cy: 28.116,
    r: 7.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.042 34.872.294-13.364s3.758 3.276 7.049 3.23c3.185-.043 7.49-3.23 7.49-3.23v13.364s-4.207-2.887-7.49-2.937c-3.385-.052-7.343 2.937-7.343 2.937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.93,
    cy: 28.116,
    r: 7.93
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 7.93,
    r: 7.93,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.07,
    cy: 7.93,
    r: 7.93,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.07,
    cy: 48.303,
    r: 7.93,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 48.303,
    r: 7.93,
    opacity: 0.3
  }))));
};
export default SvgLogoPattern;